'use client'
import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE__base_ui_components_react_popover_cdb87929__ from "@base-ui-components/react/popover";
import * as __WEBPACK_EXTERNAL_MODULE__InputButton_index_js_87fb5a42__ from "../../InputButton/index.js";
import * as __WEBPACK_EXTERNAL_MODULE__Calendar_Calendar_js_f3e0123a__ from "../Calendar/Calendar.js";
import * as __WEBPACK_EXTERNAL_MODULE__CustomComponents_Footer_js_c8ab8c4c__ from "../CustomComponents/Footer.js";
import * as __WEBPACK_EXTERNAL_MODULE__helpers_helpers_js_34fc57e9__ from "../helpers/helpers.js";
const DEFAULT_DATE_PICKER_FORMAT = 'ccc, MMM d';
function DatePicker({ mode = 'single', handleCalendarChange, footerLeftNode, subHeading, components: initialComponents, title, label, selected, displayNights, ...restProps }) {
    const [isPopOverOpen, setIsPopOverOpen] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(false);
    let initialFormattedDates = subHeading ?? '';
    if (selected && !subHeading) initialFormattedDates = (0, __WEBPACK_EXTERNAL_MODULE__helpers_helpers_js_34fc57e9__.getFormattedDates)({
        dates: selected,
        dateFormat: DEFAULT_DATE_PICKER_FORMAT,
        displayNights
    });
    const [formattedDates, setFormattedDates] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(initialFormattedDates);
    const [selectedDates, setSelectedDates] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(selected);
    const handleCalendarDates = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)((newDates)=>{
        if (!subHeading) setFormattedDates((0, __WEBPACK_EXTERNAL_MODULE__helpers_helpers_js_34fc57e9__.getFormattedDates)({
            dates: newDates,
            dateFormat: DEFAULT_DATE_PICKER_FORMAT,
            displayNights
        }));
        setSelectedDates(newDates);
        handleCalendarChange(newDates);
    }, [
        handleCalendarChange,
        subHeading,
        displayNights
    ]);
    const handlePopOverOpenState = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)((val)=>{
        setIsPopOverOpen(val);
    }, []);
    const renderInput = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)((props)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
            "data-testid": "date-picker-input",
            ...props,
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__InputButton_index_js_87fb5a42__.InputButton, {
                label: label,
                iconLeft: 'calendar_month',
                value: subHeading ?? formattedDates,
                size: 'lg'
            })
        }), [
        label,
        subHeading,
        formattedDates
    ]);
    const components = {
        ...initialComponents,
        Footer: ()=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__CustomComponents_Footer_js_c8ab8c4c__.Footer, {
                footerLeftNode: footerLeftNode,
                handleFooterCallBack: handlePopOverOpenState
            })
    };
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__base_ui_components_react_popover_cdb87929__.Popover.Root, {
        open: isPopOverOpen,
        onOpenChange: handlePopOverOpenState,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__base_ui_components_react_popover_cdb87929__.Popover.Trigger, {
                render: renderInput,
                className: ""
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__base_ui_components_react_popover_cdb87929__.Popover.Portal, {
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__base_ui_components_react_popover_cdb87929__.Popover.Positioner, {
                    sideOffset: 8,
                    align: "start",
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__base_ui_components_react_popover_cdb87929__.Popover.Popup, {
                        className: "shadow-overlay-md bg-primary-1 origin-[var(--transform-origin)] rounded-xl p-4 transition-[transform,scale,opacity] data-[ending-style]:scale-90 data-[starting-style]:scale-90 data-[ending-style]:opacity-0 data-[starting-style]:opacity-0",
                        children: [
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__base_ui_components_react_popover_cdb87929__.Popover.Arrow, {
                                className: ""
                            }),
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__base_ui_components_react_popover_cdb87929__.Popover.Title, {
                                className: "sr-only",
                                children: title
                            }),
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__Calendar_Calendar_js_f3e0123a__.Calendar, {
                                selected: selectedDates,
                                handleCalendarChange: handleCalendarDates,
                                mode: mode,
                                components: components,
                                ...restProps
                            })
                        ]
                    })
                })
            })
        ]
    });
}
export { DEFAULT_DATE_PICKER_FORMAT, DatePicker };
